module.exports = __webpack_public_path__ + "images/1.1792033684119.jpg";